<app-tab-control [id]="'dashboard-cl-tabs'" [tabs]="tabs">
  <ng-template #attributesReportTabContent>
    <app-attributes-report></app-attributes-report>
  </ng-template>

  <ng-template #alertReportTabContent>
    <app-wallet-alert-report></app-wallet-alert-report>
  </ng-template>
</app-tab-control>
